// The theme colors for the entire application.
// In this file we are only defining the colors we need

import { blueGrey, indigo } from "@mui/material/colors";

const colors = {
  border: "#efeff7",
  background: "#ffffff",
  background2: "#edf3f4",
  canvasColor: "#FFF",
  greyBackground: "#f1f2f4",
  majorBlack: "#353535",

  button: {
    active: "#4c8991",
    inactive: "#ffffff",
  },

  buttonBorder: {
    btnBorder: "#4c8991",
  },

  text: {
    main: "#4e4e4e",
    body: "#182c4e",
    subtle: "#797a80",
    footnote: "#6B778C",
    focus: "#79859C",
    navlistText: "#172b4d",
    dark: "#686868",
  },
  textField: {
    main: "#f0f2f5",
  },
  textFieldLabel: {
    main: "#65676b",
  },

  bolder: {
    main: "#191919",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#00000",
    focus: "#00000",
  },

  primary: {
    main: "#4c8991",
  },

  secondary: {
    main: "#4c8991",
  },

  info: {
    main: "#1A73E8",
    focus: "#1662C4",
  },

  success: {
    main: "#4CAF50",
    focus: "#67bb6a",
  },

  warning: {
    main: "#fb8c00",
    focus: "#fc9d26",
  },

  unfocused: {
    main: "#666666",
  },

  error: {
    main: "#F44335",
    focus: "#f65f53",
  },

  light: {
    main: "#f0f2f5",
    focus: "#f0f2f5",
  },

  dark: {
    main: "#202124",
    focus: "#2c3c58",
  },

  grey: {
    100: "#f8f9fa",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  icons: {
    main: "#989898",
    icon2: "#172b4d",
  },

  descriptionIcon: {
    main: "#e16745",
  },

  gradients: {
    primary: {
      main: "#EC407A",
      state: "#D81B60",
    },

    secondary: {
      main: "#747b8a",
      state: "#495361",
    },

    info: {
      main: "#49a3f1",
      state: "#1A73E8",
    },

    success: {
      main: "#66BB6A",
      state: "#43A047",
    },

    warning: {
      main: "#FFA726",
      state: "#FB8C00",
    },

    error: {
      main: "#EF5350",
      state: "#E53935",
    },

    light: {
      main: "#EBEFF4",
      state: "#CED4DA",
    },

    dark: {
      main: "#42424a",
      state: "#191919",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },
  },

  badgeColors: {
    primary: {
      background: "#f8b3ca",
      text: "#cc084b",
    },

    secondary: {
      background: "#5c7db2",
      text: "#6c757d",
    },

    info: {
      background: "#e7eff9",
      text: "#095bc6",
    },

    success: {
      background: "#edf8f0",
      text: "#339537",
    },

    warning: {
      background: "#fff8f0",
      text: "#c87000",
    },

    error: {
      background: "#ffecec",
      text: "#f61200",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      background: "#8097bf",
      text: "#1e2e4a",
    },
  },

  coloredShadows: {
    primary: "#e91e62",
    secondary: "#110e0e",
    info: "#00bbd4",
    success: "#4caf4f",
    warning: "#ff9900",
    error: "#f44336",
    light: "#adb5bd",
    dark: "#404040",
  },

  inputBorderColor: "#d2d6da",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
